module.exports = __webpack_public_path__ + "static/img_pledge_01@2x-80fd80759e813d859e2d05f5f1b549c7.png";